import React, { useEffect, useRef, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as BellIcon } from 'assets/icons/bell-full.svg'
import { ROUTES } from 'shared/config/routes'
import { prioritySummaryStore } from 'shared/stores/prioritySummaryStore'
import s from './styles/NotificationDropdown.module.scss'
import { ReactComponent as DocIcon } from 'assets/icons/dock.svg'
import { ReactComponent as EditIcon } from 'assets/icons/dock_pen.svg'
import { ReactComponent as MessageIcon } from 'assets/icons/message.svg'
import { ReactComponent as ListIcon } from 'assets/icons/list.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import { ReactComponent as ChatIcon } from 'assets/icons/messages.svg'
import { ReactComponent as AssignmentIcon } from 'assets/icons/assignment.svg'

export const notificationIcons = {
	documents: DocIcon,
	essay_review: EditIcon,
	essay_feedback: MessageIcon,
	shortlist: ListIcon,
	lor: MailIcon,
	lor_requests: MailIcon,
	lor_uploaded: DocIcon,
	student_chat: ChatIcon,
	assignments: AssignmentIcon,
}

const NotificationDropdown = observer(({ compact = false }) => {
	const navigate = useNavigate()
	const rootRef = useRef(null)
	const [open, setOpen] = useState(false)

	useEffect(() => {
		if (!open) return undefined
		prioritySummaryStore.refresh()
		const onDoc = e => {
			if (!rootRef.current?.contains(e.target)) {
				setOpen(false)
			}
		}
		document.addEventListener('mousedown', onDoc)
		return () => document.removeEventListener('mousedown', onDoc)
	}, [open])

	const rows = prioritySummaryStore.notificationSummaryRows
	const badge = prioritySummaryStore.notificationBellBadgeText

	const handleRowAction = row => {
		setOpen(false)

		switch (row.action) {
			case 'applications':
				navigate(ROUTES.APPLICATIONS, {
					state: { needsAttention: ['new_application'] },
				})
				break
			case 'priority':
				navigate(ROUTES.HOME, {
					state: {
						priorityTab: row.tab,
						scrollToPriority: true,
					},
				})
				break
			case 'classroom_new':
				navigate(ROUTES.CLASSROOM, {
					state: { filterIds: ['new'] },
				})
				break
			case 'messages':
				navigate(ROUTES.MESSAGES)
				break
			default:
				break
		}
	}

	return (
		<div className={s.root} ref={rootRef}>
			<button
				type="button"
				className={`${s.trigger} ${compact ? s.trigger_compact : ''}`}
				onClick={() => setOpen(v => !v)}
				aria-label="Notifications"
			>
				<span className={s.trigger__icon}>
					<BellIcon />
				</span>
				{badge ? (
					<span
						className={`${s.trigger__badge} ${
							compact ? s.trigger__badge_compact : ''
						}`}
					>
						{badge}
					</span>
				) : null}
			</button>
			{open ? (
				<div className={s.menu}>
					<div className={s.menu__head}>
						<h4 className={s.menu__title}>Notifications</h4>
						<p className={s.menu__sub}>Activity updates</p>
					</div>
					<div className={s.menu__list}>
						{rows.length === 0 ? (
							<div className={s.empty}>No new updates</div>
						) : (
							rows.map(row => {
								const Icon = notificationIcons[row.id]
								return (
									<div className={s.row} key={row.id}>
										<div className={s.row__left}>
											<span className={s.row__icon}>
												{Icon ? <Icon /> : null}
											</span>
											<span className={s.row__text}>{row.label}</span>
											<span className={s.row__count}>{row.count}</span>
										</div>
										<button
											type="button"
											className={s.row__cta}
											onClick={() => handleRowAction(row)}
										>
											View
										</button>
									</div>
								)
							})
						)}
					</div>
				</div>
			) : null}
		</div>
	)
})

export default NotificationDropdown
